import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Legacy hash URLs (#/foo) → path URLs (/foo).
// Runs before bootstrap so the router only ever sees the canonical form.
// Preserves subdirectory deploys (e.g. /mytreatsuat/#/login → /mytreatsuat/login)
// and query params before the hash (e.g. /mytreatsuat/?a=1#/login → /mytreatsuat/login?a=1).
if (location.hash.startsWith('#/')) {
  const hashPathAndQuery = location.hash.slice(1); // "/login?x=1"
  const basePath = location.pathname.replace(/\/$/, '') || '';
  const search = location.search || '';
  const targetPath =
    basePath && basePath !== '/'
      ? `${basePath}${hashPathAndQuery.startsWith('/') ? '' : '/'}${hashPathAndQuery}`
      : hashPathAndQuery;
  const target =
    search && !targetPath.includes('?') ? `${targetPath}${search}` : targetPath;
  history.replaceState(null, '', target);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .catch((err) => console.error(err));
